module.exports = {
    INDIRECT: 'Indirect',
    DIRECT: 'Direct',
};
